import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import Select from "components/elements/Select";
import {
  USER_BUSINESS_ADMIN,
  USER_CLIENT_MANAGER,
  USER_OPS,
  USER_SUPERADMIN,
} from "core/Constants";

import IconButton from "components/elements/IconButton";
import dataProvider from "core/DataProvider";

const AddInternalUser = props => {
  const [activeTab, setActiveTab] = useState(0);
  const [formVisible, setFormVisible] = useState(false);

  const [id, setID] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [userType, setUserType] = useState(null);

  const addUser = async () => {
    if (!name) {
      toast.error("Please enter a valid name");
      return;
    }

    if (!email) {
      toast.error("Please enter a valid email");
      return;
    }

    if (!department) {
      toast.error("Please enter a department");
      return;
    }

    if (!userType) {
      toast.error("Please select a user type");
      return;
    }

    let permissions = [];
    const data = {
      id: id ? id : 0,
      name,
      email,
      department,
      user_type: userType.value,
      permissions,
    };

    try {
      await dataProvider.network.post("users/add", data);

      setFormVisible(false);
      props.onComplete();
      toast.success(
        props.editUser
          ? "User modified successfully"
          : "User created successfully"
      );
    } catch (error) {
      console.error(error);
      toast.error(
        props.editUser ? "Failed to modify user" : "Failed to create user"
      );
    }
  };

  const tabData = [
    {
      title: "User Details",
      content: (
        <div className="tab-body">
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Department"
                value={department}
                onChange={e => setDepartment(e.target.value)}
              />
            </div>
            <div className="el flex-full">
              <Select
                value={userType}
                onChange={e => setUserType(e)}
                placeholder="Type"
                options={[
                  { label: "Super Admin", value: USER_SUPERADMIN },
                  { label: "Business Admin", value: USER_BUSINESS_ADMIN },
                  { label: "Client Manager", value: USER_CLIENT_MANAGER },
                  { label: "Operations", value: USER_OPS },
                ]}
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  const cancel = () => {
    setFormVisible(false);

    setID(null);
    setName("");
    setEmail("");
    setDepartment("");
    setUserType(null);

    props.cancel();
  };

  // update view on edit user
  useEffect(() => {
    if (props.editUser) {
      setID(props.editUser.id);
      setName(props.editUser.name);
      setEmail(props.editUser.email);
      setDepartment(props.editUser.department);
      setUserType({
        label: props.editUser.user_type,
        value: props.editUser.user_type_int,
      });

      setFormVisible(true);
    }
  }, [props.editUser]);

  return (
    <div>
      <div className="flex">
        <div className="right flex flex-v-center">
          {formVisible ? (
            <>
              <IconButton
                text={props.editUser ? "Update" : "Save"}
                onClick={addUser}
              />
              <IconButton text="Cancel" onClick={cancel} />
            </>
          ) : (
            <IconButton
              icon="add"
              text="New User"
              onClick={() => setFormVisible(true)}
            />
          )}
        </div>
      </div>
      {formVisible && (
        <div className="box mtop pad-1">
          <div className="tabs">
            {tabData.map((tab, index) => (
              <div
                key={index}
                className={activeTab === index ? "tab-head active" : "tab-head"}
                onClick={_ => setActiveTab(index)}
              >
                {tab.title}
              </div>
            ))}
          </div>
          <div className="tab-content">{tabData[activeTab].content}</div>
        </div>
      )}
    </div>
  );
};

export default AddInternalUser;
